import React, {createRef, RefObject} from "react"

import GDTree from "../../../../gd-ui/tree/gd-tree"

const MIN_SEARCH_TEXT_LENGTH = 2

type Props = {
    treeSource?     : any

    parentProjectId?: ID
    onClickProject  : {(project: any):void} // project - ProjectModelSession
    onTab           : {():void}
}

const debug = false
// const debug = "ProjectFinderMain"

export default class ProjectFinderMain extends React.Component<Props,any> {

    treeSource          : any
    delayedProjectSearch: any
    gdTreeRef           : RefObject<any>

    constructor(props:Props) {
        super(props);

        this.gdTreeRef = createRef()

        this.treeSource = this.props.treeSource || gd.tree

        this.state = {
            search          : '',
            isSearching     : false,
            expanded        : null,
            data            : null
        }

        this.delayedProjectSearch = _.debounce(this.projectsSearch, 500)
    }

    onSearchChange = (value:string) => {
        const isSearching = value.length >= MIN_SEARCH_TEXT_LENGTH;
        if (this.state.search && !value) {
            this.onSearchCancel()
        } else {
            this.setState({
                search      : value,
                isSearching : isSearching,
                data        : null
            }, ()=>{
                if (isSearching) this.delayedProjectSearch()
            })
        }
    }

    onSearchCancel = () => {
        this.setState({
            isSearching : false,
            search      : '',
            data        : null
        })
    }

    projectsSearch = () => {
        debug && console.log(debug, 'projectsSearch', this.state.search)

        const baseProjects  = _.filter(gd.session.projects.models, p=>[gd.companyId].includes(p.companyId)).map(p=>({item:p}))
        let matchedProjects: any[] = baseProjects.slice()

        const expandedUpdated               = this.state.expanded ? this.state.expanded : {companies:[],projects:[]}
        let expandedCompaniesBySearch: ID[] = []
        let expandedProjectsBySearch: ID[]  = []

        const matchString = this.state.search.toLowerCase()
        matchedProjects = _.filter(matchedProjects, p=>p.item.name.toLowerCase().includes(matchString))

        matchedProjects.map(mp=>{
            const parentProjects = this.treeSource.findProjectParents(this.treeSource.getProject(mp.item.id)).map((p:any)=>p.id)
            expandedCompaniesBySearch.push(mp.item.companyId);
            expandedProjectsBySearch = expandedProjectsBySearch.concat(parentProjects);
        });

        expandedUpdated.companies = _.union(expandedUpdated.companies, expandedCompaniesBySearch);
        expandedUpdated.projects = _.union(expandedUpdated.projects, expandedProjectsBySearch);

        debug && console.log(debug, 'projectsSearch done', matchedProjects, expandedUpdated)

        this.setState({
            isSearching : false,
            expanded    : expandedUpdated,
            data        : matchedProjects
        });
    }

    onParentSelected = (data: {
        projectId: ID,
        companyId: ID
    } | null) => {
        const project = data?.projectId ? gd.session.projects.get(data?.projectId) : null

        debug && console.log(debug, 'onParentSelected', project, this.props.onClickProject, data)

        if (project && this.props.onClickProject) this.props.onClickProject(project)
    }

    onKeyDown = (event:any) => {
        this.gdTreeRef.current.onKeyDown(event)
    }

    render() {
        const selectedValue = this.props.parentProjectId ? {projectId:this.props.parentProjectId} : null
        const nothingFound  = this.state.search && _.isEmpty(this.state.data)

        debug && console.log(debug, 'render', selectedValue, nothingFound, this.state)

        return (
            <div className='project-selector-main'>
                {this.state.isSearching &&
                    <div className="searching-label">Searching projects...</div>}

                {!this.state.isSearching &&
                    <>
                        {!nothingFound &&
                            <GDTree ref={this.gdTreeRef}
                                    companies={[gd.companyId]}
                                    expanded={this.state.expanded}
                                    filterProjects={this.state.data}
                                    value={selectedValue}
                                    singleCompanyVisible={false}
                                    showOnlyFilterProjects={!!this.state.data}
                                    showProjectIcon={true}
                                    noCollapseExpand={false}
                                    filterByAccess={true}
                                    scrollToSelected={true}
                                    highlightOnHover={true}
                                    onChange={this.onParentSelected}
                                    onTab={this.props.onTab}/>}

                        {nothingFound &&
                            <div className="not-found">No folders/projects found</div>}
                    </>}
            </div>
        )
    }
}